<form [formGroup]="senhaForm">
    <mat-form-field>
        <mat-label>{{ "PASSWORD_VALIDATOR.PASSWORD" | translate }}</mat-label>
        <input
            [id]="'input_redefinir-senha_Senha'"
            matInput
            required
            maxlength="20"
            type="password"
            formControlName="senha"
            #senha
        />
        <mat-icon matSuffix color="secondary" (click)="senha.type = senha.type == 'text' ? 'password' : 'text'">
            {{ senha.type == "text" ? "visibility_off" : "visibility" }}
        </mat-icon>
        <mat-hint align="end"> {{ senha.value.length }} / 20 </mat-hint>
    </mat-form-field>

    <div class="ml-1">
        <!-- Validação customizada quando passwordCustomRules está presente -->
        <ng-container *ngIf="passwordCustomRules && customRules.length > 0">
            <li class="small-font" *ngFor="let rule of customRules; let i = index">
                {{ rule }}
                <mat-icon *ngIf="isRuleValid(i)" style="color: #008000">done</mat-icon>
                <mat-icon *ngIf="!isRuleValid(i)" style="color: #ff0000">close</mat-icon>
            </li>
        </ng-container>

        <!-- Validação customizada quando passwordRegex está presente mas não há regras customizadas -->
        <li class="small-font" *ngIf="passwordRegex && (!passwordCustomRules || customRules.length === 0)">
            {{ "PASSWORD_VALIDATOR.CUSTOM_PATTERN" | translate }}
            <mat-icon
                *ngIf="
                    !senhaForm.get('senha')?.hasError('required') &&
                    !senhaForm.get('senha')?.hasError('customPasswordPattern')
                "
                style="color: #008000"
                >done</mat-icon
            >

            <mat-icon
                *ngIf="
                    !senhaForm.get('senha')?.hasError('required') &&
                    senhaForm.get('senha')?.hasError('customPasswordPattern')
                "
                style="color: #ff0000"
                >close</mat-icon
            >
        </li>

        <!-- Validações padrão quando passwordRegex não está presente e não há regras customizadas -->
        <ng-container *ngIf="!passwordRegex && (!passwordCustomRules || customRules.length === 0)">
            <li class="small-font">
                {{ "PASSWORD_VALIDATOR.MINLENGTH" | translate }}
                <mat-icon
                    *ngIf="
                        !senhaForm.get('senha')?.hasError('required') && !senhaForm.get('senha')?.hasError('minlength')
                    "
                    style="color: #008000"
                    >done</mat-icon
                >

                <mat-icon *ngIf="senhaForm.get('senha')?.hasError('minlength')" style="color: #ff0000">close</mat-icon>
            </li>

            <li class="small-font">
                {{ "PASSWORD_VALIDATOR.UPPERCASE" | translate }}
                <mat-icon
                    *ngIf="
                        !senhaForm.get('senha')?.hasError('required') &&
                        !senhaForm.get('senha')?.hasError('notUppercase')
                    "
                    style="color: #008000"
                    >done</mat-icon
                >

                <mat-icon
                    *ngIf="
                        !senhaForm.get('senha')?.hasError('required') &&
                        senhaForm.get('senha')?.hasError('notUppercase')
                    "
                    style="color: #ff0000"
                    >close</mat-icon
                >
            </li>

            <li class="small-font">
                {{ "PASSWORD_VALIDATOR.SPECIAL_CHARACTER" | translate }}
                <mat-icon
                    *ngIf="
                        !senhaForm.get('senha')?.hasError('required') &&
                        !senhaForm.get('senha')?.hasError('notSpecialCharacter')
                    "
                    style="color: #008000"
                    >done</mat-icon
                >

                <mat-icon
                    *ngIf="
                        !senhaForm.get('senha')?.hasError('required') &&
                        senhaForm.get('senha')?.hasError('notSpecialCharacter')
                    "
                    style="color: #ff0000"
                    >close</mat-icon
                >
            </li>
        </ng-container>
    </div>

    <mat-form-field>
        <mat-label>{{ "PASSWORD_VALIDATOR.PASSWORD_CONFIRMATION" | translate }}</mat-label>
        <input
            [id]="'input_redefinir-senha_ConfirmacaoSenha'"
            matInput
            required
            maxlength="20"
            type="password"
            formControlName="confirmaSenha"
            #inputConfirmPassword
        />
        <mat-icon
            matSuffix
            color="secondary"
            (click)="inputConfirmPassword.type = inputConfirmPassword.type == 'text' ? 'password' : 'text'"
        >
            {{ inputConfirmPassword.type == "text" ? "visibility_off" : "visibility" }}
        </mat-icon>

        <mat-error
            *ngIf="
                senhaForm.invalid &&
                senhaForm.controls['confirmaSenha'].hasError('required') &&
                !senhaForm.controls['confirmaSenha'].hasError('MatchPassword')
            "
            >{{ "PASSWORD_VALIDATOR.REQUIRED" | translate }}</mat-error
        >
        <mat-error
            *ngIf="
                senhaForm.invalid &&
                !senhaForm.controls['confirmaSenha'].hasError('required') &&
                senhaForm.controls['confirmaSenha'].hasError('MatchPassword')
            "
            >{{ "PASSWORD_VALIDATOR.MUST_MATCH" | translate }}</mat-error
        >
    </mat-form-field>
</form>
